import { JsonRestApiRequestConfig, makeJsonRestApiRequest } from '~src/httpClient/RestApiService';

export interface IGetAuthFederationConnectorResponse {
  connector: {
    luid: string;
    connectorClass: string;
    audience: string;
  };
}

export function getAuthFederationConnectorRequestConfig(luid: string): JsonRestApiRequestConfig {
  return {
    restApiVersion: '3.30',
    httpMethod: 'GET',
    endpoint: `auth-federation/admin/connectors/${luid}`,
    serverWideRequest: false
  };
}

export function callGetAuthFederationConnectorRequest(
  luid: string
): Promise<IGetAuthFederationConnectorResponse> {
  return makeJsonRestApiRequest<null, any>({
    config: getAuthFederationConnectorRequestConfig(luid),
    request: null
  }).then((response) => {
    return {
      connector: response.authFederationConnector
    };
  });
}
